<div class="authorization-consent" *ngIf="!loading && activeVersion; else loadingOrEmpty"
    role="region" aria-label="Payment authorization">
    <div *ngIf="showRefreshedBanner" class="authorization-consent__refreshed-banner" role="alert">
        <mat-icon>info</mat-icon>
        <span>
            This authorization notice was updated. Please review the updated
            text above and submit again to re-authorize.
        </span>
    </div>

    <div class="authorization-consent__text" [id]="textElementId" [innerHTML]="safeHtmlText"></div>
</div>

<ng-template #loadingOrEmpty>
    <div *ngIf="loading" class="authorization-consent__loading">
        <mat-spinner diameter="20"></mat-spinner>
    </div>
    <!--
        When `activeVersion` is null and not loading, render nothing. This is the
        legitimate "Credit no-op" case where the tenant has not configured any
        text and no AdHoc fallback resolves; the disclosure is omitted from the
        page entirely. The parent's submit will omit the authorizationConsent
        payload accordingly.
    -->
</ng-template>
